import React from "react";
import { useLocation } from "react-router-dom";
// import LoginForm from "../_auth/LoginForm";
import LoginForm from "../_auth/StepWiseLogin/LoginForm"
import bgimg from "../assets/loginbg.png";
const LoginPage = () => {
  const location = useLocation();

  // Get the selected tab from navigation state, default to 'Buyer' if not present
  const selectedTab = location.state?.selectedTab || 'Buyer';

  const handleLogin = async (formData) => {
    // Handle login logic here
    // Example: await authService.login(formData);
  };
  return (
    <div className="w-full" >
      {/* <LoginForm /> */}
      <LoginForm
        type='login'
        tabs={["Buyer", "Seller"]}
        defaultTab={selectedTab}
        onSubmit={handleLogin}
      />
    </div>
  );
};

export default LoginPage;
